

import SlDetails from '@shoelace-style/shoelace/dist/react/details';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon';

const css = `
  .faq-wrapper {
    sl-details {
        margin: 35px 0px;
        text-align: start;
    }
    sl-details.custom-icon::part(summary-icon) {
        /* Disable the expand/collapse animation */
        rotate: none;
      }
  }
`;

const FAQ = () => {
  return (
  <div className={"faq-wrapper"}>
    <SlDetails summary="What is HomeKeepy?" className="custom-icon">
      <SlIcon name="plus-square" slot="expand-icon" />
      <SlIcon name="dash-square" slot="collapse-icon" />
      <b>HomeKeepy</b> focuses on making the most <b>complex and stressfful</b> part of property management <b>easy and stress free</b>: the <b>repair and maintenance</b> that keeps the units <b>competitive in the market</b>. <br/><br/> 
      HomeKeepy is built for <b>property managers, management companies, owners, landlords, investors, tenants</b> . Our goal is to make your life easier so you get more done in less time, increase occupancy and profitability, and reduce turnover.<br/><br/> 
      We automate repetitive tasks and heavily leverage <b>AI tools</b> so you can focus on what truly matters: <b>building business relationships and growing your business.</b>
    </SlDetails>

        <SlDetails summary="How HomeKeepy is better than other property managment softwares?" className="custom-icon">
      <SlIcon name="plus-square" slot="expand-icon" />
      <SlIcon name="dash-square" slot="collapse-icon" />
      Real estate operations are <b>inherently complex:</b> listing properties, placing tenants, acquiring assets, managing investors, and handling accounting and finance. Platforms that try to cover everything inevitably become bloated, inefficient, and unfocused.<br/><br/>
      HomeKeepy takes a <b>different approach</b>. We focus on <b>one mission and execute it exceptionally well</b>. By deeply integrating <b>AI agents and proprietary knowledge databases</b>, we centralize and operationalize everything related to property maintenance and repairs.<br/><br/>
      Our system doesn’t just react to issues. It proactively <b>guides vendors, enforces best practices, and protects the most valuable asset</b> in real estate: the property itself. The result is lower operating costs, faster resolution times, higher asset performance, and stronger long-term returns. HomeKeepy turns maintenance from a cost center into a competitive advantage.
    </SlDetails>

    <SlDetails summary="What type of properties can I manage?" className="custom-icon">
      <SlIcon name="plus-square" slot="expand-icon" />
      <SlIcon name="dash-square" slot="collapse-icon" />
     
- Residential properties: Single and Multifamily.<br/>
- Commercial properties.<br/>
- Student housing.<br/>
- Mobile homes.<br/>

    </SlDetails>

    <SlDetails summary="What is the process to get started?" className="custom-icon">
      <SlIcon name="plus-square" slot="expand-icon" />
      <SlIcon name="dash-square" slot="collapse-icon" />
      
1. Create an account (New User)<br/>
2. Schedule a demo.<br/>
3. Migrate or input your data. We do this process for free.<br/>
4. Watch Videos about how to manage the platform in the training section.<br/>
5. Email your tenants and vendors a link to their new portal. Tenants can submit repair requests and vendors will track their tasks from repair request to completion.<br/>

    </SlDetails>
    <SlDetails summary="What are the prices and why it is so cheap?" className="custom-icon">
      <SlIcon name="plus-square" slot="expand-icon" />
      <SlIcon name="dash-square" slot="collapse-icon" />
      - Only 20 $/month for the first 10 units.‍ It includes software updates, data migration, training and support.<br/><br/>
      - We are a private company with low headcount and AI driven.
    </SlDetails>
    <SlDetails summary="Do I need a credit card to try it" className="custom-icon">
      <SlIcon name="plus-square" slot="expand-icon" />
      <SlIcon name="dash-square" slot="collapse-icon" />
     No Credit Card needed. You can create an account and schedule a demo. No payment required.
    </SlDetails>
    <SlDetails summary="Are there any contracts?" className="custom-icon">
      <SlIcon name="plus-square" slot="expand-icon" />
      <SlIcon name="dash-square" slot="collapse-icon" />
     No contracts. You are free to cancel your account at any time or export your data.
    </SlDetails>
    <SlDetails summary="How to migrate data to HomeKeepy?" className="custom-icon">
      <SlIcon name="plus-square" slot="expand-icon" />
      <SlIcon name="dash-square" slot="collapse-icon" />
     Either spreadsheet, APIs or PDF, we will take care of the data migration with information about properties, units, tenants and vendors.
    </SlDetails>
{/*     <SlDetails summary="Is my data backed up and protected?" className="custom-icon">
      <SlIcon name="plus-square" slot="expand-icon" />
      <SlIcon name="dash-square" slot="collapse-icon" />
     Yes, sleep well knowing your data is automatically backed to numerous servers. If you wish, you can export and save a physical copy of your data to your computer.
DoorLoop is hosted by Amazon Web Services (AWS), the leader in data security.
    </SlDetails> */}


    <style>{css}</style>
  </div>
)};

export default FAQ;